import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Typography,
} from "@material-ui/core";
import {Locations} from "./DataSourceSettings.Locations";
import {Matrix} from "./DataSourceSettings.Matrix";

const useStyles = makeStyles((theme) => ({
  root: {
  },
  locations: {
    backgroundColor: theme.palette.venueSettings.dataSources.locationsBackground,
    height: `${47 + 90 + 50*10}px`   // KF: The flexbox (row direction) that contains the list of locations and the matrix
                                     // must have the height of the matrix. If the list of locations is long, then it is
                                     // displayed with a vertical scrollbar.
                                     // I cannot find a way to set the flexbox's height to the height of its shortest child.
                                     // So, at least for time being, I calculate the height of the potentially taller 
                                     // child from the number of the indicators, which is 10 at the moment.
  },
  title: {
    textTransform: "uppercase",
    fontWeight: "500",
    fontSize: "15px",
    padding: "15px 20px 5px 20px",
  }
}));

export const DataSourceSettings = ({venue}) => {
  const classes = useStyles();

  // KF: Awful hack, out of desperation. Some pages, like the current 
  // one must not extend below the screen line. Instead, the content 
  // should get vertical scroll bar(s) if needed. The majority of 
  // pages though, use the page's scroll bar and it's OK for them 
  // to extend down as much as their content needs.
  // useEffect(() => {
  //   document.getElementsByName("main")[0].style.height = "100vh";
  //   return () => {
  //     document.getElementsByName("main")[0].style.height = "";
  //   };
  // }, []);

  const [location, setLocation] = useState({locationId: "", isSensor: false});

  return (
    // This Box contains the loading component and another Box with the settings, on top of each other.
    <Box
      className={classes.root}
      sx={{
        width: "100%",
        display: "flex",
        alignItems: "start",
        //flexGrow: 1,
        minHeight: 0
      }}
    >
      <Box
        className={classes.locations}
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "350px",
          overflow: "auto",
          minHeight: 0,
        }}>
          <Typography
            className={classes.title}>
            Locations
          </Typography>
          <Locations 
            venue={venue}
            onLocationSelected={({locationId, isSensor}) => setLocation({locationId: locationId, isSensor: isSensor})}
          />
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "start",
          flexDirection: "column",
          //height: "auto",
          flexGrow: 1,
          minHeight: 0,
          ml: 3
        }}>
          <Matrix 
            venue={venue} 
            location={location}
          />
      </Box>
    </Box>
  );
};

export default DataSourceSettings;